import React, { useState, useEffect } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import './Home.css';
import { apilink } from '../../data/fdata';
import CircularProgress from '@mui/material/CircularProgress';
import { useAlert } from 'react-alert';
import SideBar from '../../component/sidebar/SideBar';
import Footer from '../../component/footer/Footer';

const Home = ({ userDetails }) => {
  const alert = useAlert();
  const his = useHistory();
  const [showstatus, setShowstatus] = useState(false);
  const hecord_tokon = Cookies.get('_hecord_access_user_tokon_');
  const [account, setAccount] = useState([]);
  const [postimg, setPostimg] = useState([]);
  const [postprev, setPostprev] = useState(false);
  const [medical, setMedical] = useState([]);
  const [imgloading, setImgLoading] = useState(false);
  const [symtomsById, setSymtomsById] = useState([]);
  useEffect(() => {
    // 👇️ scroll to top on page load
    getMedical();
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);
  useEffect(() => {
    setAccount(userDetails);
  }, [userDetails]);
  const handelImg = async (e) => {
    const { files } = e.target;
    if (files.length > 0) {
      if (
        files[0].type === 'image/jpeg' ||
        files[0].type === 'image/jpg' ||
        files[0].type === 'image/png'
      ) {
        if (files[0].size > 1024 * 1024) {
          alert.error('File Size is Too Large');
        } else {
          setPostimg(files[0]);
          setPostprev(true);

          setImgLoading(true);
          let formData = new FormData();
          formData.append('file', files[0]);
          // console.log(files);

          const res = await axios.post(
            `${apilink}/api/upload/avatar`,
            formData,
            {
              headers: {
                Authorization: hecord_tokon,
              },
            }
          );
          if (res.data.success) {
            setAccount({ ...account, profile_image: res.data.url });
            getAccount();
          } else {
            alert.error(res.data.msg);
          }
          setImgLoading(false);
        }
      } else {
        alert.error('Only PNG, JPEG, JPG');
      }
    }
  };

  const getAccount = async () => {
    const res = await axios.get(`${apilink}/api/user/getUserInfor`, {
      headers: {
        Authorization: hecord_tokon,
      },
    });
    // console.log(res.data);
    if (res.data.success) {
      setAccount(res.data.userAccount);
    } else {
      if (res.data.msg == 'Invalid Authentication.') {
        // his.push('/login');
        Cookies.remove('_hecord_access_user_tokon_');
        localStorage.removeItem('_hecord_access_user_login');
        console.clear();
        his.push('/');
      } else {
        console.log(res.data.msg);
      }
    }
  };
  const getMedical = async () => {
    const res = await axios.get(`${apilink}/api/user/getUserMedical`, {
      headers: {
        Authorization: hecord_tokon,
      },
    });
    // console.log(res.data);
    if (res.data.success) {
      setMedical(res.data.userMedical);
    } else {
      if (res.data.msg == 'Invalid Authentication.') {
        // his.push('/login');
        Cookies.remove('_hecord_access_user_tokon_');
        localStorage.removeItem('_hecord_access_user_login');
        console.clear();
        his.push('/');
      } else {
        console.log(res.data.msg);
      }
    }
  };

  const getSymtomsById = (id) => {
    setShowstatus(true);
    const res = medical.filter((v) => v.event_id == id);
    setSymtomsById(res);
  };
  // console.log(symtomsById);

  useEffect(async () => {
    const res = await axios.get(`${apilink}/auth/isVerify`, {
      headers: {
        Authorization: hecord_tokon,
      },
    });
    // console.log(res.data);
    if (!res.data.success) {
      his.push('/');
    }
  }, []);

  return (
    <>
      <div className="whole__page">
        <div className="left_side_navbar">
          <SideBar />
        </div>
        <div className="main_div home">
          <div className="main_inner_div">
            <div className="row">
              <div className="col-lg-3 col-md-5 col-sm-5 col-12 mx-auto mb-3">
                <div className="card pt-2 pb-2 pl-1 pr-1">
                  <div>
                    <div className="">
                      <div>
                        {imgloading ? (
                          <div className="text-center p-2">
                            <CircularProgress size={35} />
                          </div>
                        ) : (
                          <>
                            <img
                              src={
                                account?.profile_image
                                  ? account?.profile_image
                                  : 'https://res.cloudinary.com/du9emrtpi/image/upload/v1660128327/avatar/user_beo1wf.png'
                              }
                              alt="logo"
                              className="userimg d-block mx-auto"
                            />
                          </>
                        )}
                      </div>
                      <div className="text-center mt-2">
                        <label htmlFor="file">
                          <p className="textb">Upload Photo</p>
                          <input
                            style={{ display: 'none' }}
                            type="file"
                            id="file"
                            onChange={handelImg}
                            accept=".png,.jpeg,.jpg"
                          />
                        </label>
                        <div class="alert alert-warning m-3 fn_12 p-1">
                          Upload New Photo. Maximum upload size
                          <strong> 2 MB</strong>
                        </div>
                      </div>
                    </div>
                    <div className="text-center mt-3">
                      <h5 className="mtt">
                        {account?.firstname &&
                          account?.firstname +
                            ' ' +
                            account?.middlename +
                            ' ' +
                            account?.lastname}
                      </h5>
                      <span className="fontsize">
                        Member Since:{' '}
                        {account?.date &&
                          new Date(account?.date).toLocaleDateString()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-9 col-md-7 col-sm-7 col-12 mx-auto mb-3">
                <div className="card p-3 blob_box">
                  <h5 className="text_blue">User Details</h5>
                  <hr />
                  <div className="row">
                    <div className="col-lg-6 col-md-12 mx-auto mb-2">
                      <h5>
                        <span>Name: </span>
                        {account?.firstname &&
                          account?.firstname +
                            ' ' +
                            account?.middlename +
                            ' ' +
                            account?.lastname}
                      </h5>
                    </div>
                    <div className="col-lg-6 col-md-12 mx-auto mb-2">
                      <h5>
                        <span>Email: </span>
                        {account?.email && account?.email}
                      </h5>
                    </div>
                    <div className="col-lg-6 col-md-12 mx-auto mb-2">
                      <h5>
                        <span>Date of Birth: </span>{' '}
                        {account?.dateOfBirth &&
                          new Date(account?.dateOfBirth).toLocaleDateString()}
                      </h5>
                    </div>
                    <div className="col-lg-6 col-md-12 mx-auto mb-2">
                      <h5>
                        <span>Blood Group: </span>{' '}
                        {account?.blood_group && account?.blood_group}
                      </h5>
                    </div>
                    <div className="col-lg-6 col-md-12 mx-auto mb-2">
                      <h5>
                        <span>Phone:</span> {account?.phone && account?.phone}
                      </h5>
                    </div>
                    <div className="col-lg-6 col-md-12  mb-2">
                      <h5>
                        <span>Gender:</span>{' '}
                        {account?.gender && account?.gender}
                      </h5>
                    </div>
                  </div>
                  <hr />
                  <h5 className="h5_text text_blue">Address</h5>
                  <div className="row">
                    <div className="col-lg-6 col-md-12 mx-auto mb-2">
                      <h5>
                        <span>House No:</span>{' '}
                        {account?.houseno && account?.houseno}
                      </h5>
                    </div>
                    <div className="col-lg-6 col-md-12 mx-auto mb-2">
                      <h5>
                        <span>Street:</span>{' '}
                        {account?.street && account?.street}
                      </h5>
                    </div>
                    <div className="col-lg-6 col-md-12 mx-auto mb-2">
                      <h5>
                        <span>City:</span> {account?.city && account?.city}
                      </h5>
                    </div>
                    <div className="col-lg-6 col-md-12 mx-auto mb-2">
                      <h5>
                        <span>State:</span> {account?.state && account?.state}
                      </h5>
                    </div>
                    <div className="col-lg-6 col-md-12 mx-auto mb-2">
                      <h5>
                        <span>District: </span>
                        {account?.district && account?.district}
                      </h5>
                    </div>

                    <div className="col-lg-6 col-md-12 mx-auto mb-2">
                      <h5>
                        <span>Country:</span>{' '}
                        {account?.country && account?.country}
                      </h5>
                    </div>
                    <div className="col-lg-6 col-md-12 mb-2">
                      <h5>
                        <span>Zip:</span> {account?.zip && account?.zip}
                      </h5>
                    </div>
                  </div>
                  {/* <div className="text-right edit_text">
                  <NavLink to="/account/setting">
                    <i className="fa fa-edit"></i>
                  </NavLink>
                </div> */}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12 mx-auto">
                <div className="card p-3 blob_box">
                  <h5 className="text_blue mb-2">Medical Details</h5>
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Organization</th>
                          <th>Details</th>
                        </tr>
                      </thead>
                      <tbody>
                        {medical.length > 0 ? (
                          <>
                            {medical?.map((val, ind) => {
                              return (
                                <>
                                  <tr>
                                    <td>
                                      {new Date(val.date).toLocaleDateString()}
                                    </td>
                                    <td>
                                      <p className="linkp">{val.orgName}</p>
                                    </td>
                                    <td>
                                      <p
                                        className="linkp"
                                        onClick={() =>
                                          getSymtomsById(val.event_id)
                                        }
                                      >
                                        {val.symptoms}
                                      </p>
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                          </>
                        ) : (
                          <>
                            <div className="text-center">
                              <p>No Data</p>
                            </div>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showstatus && (
        <div className="modbox">
          <div className="bigbox">
            <div className="btn_close" onClick={() => setShowstatus(false)}>
              X
            </div>
            <p className="m-0">
              <span className="text-success">Org Code: </span>{' '}
              {symtomsById[0].orgCode}
            </p>
            <p className="m-0">
              <span className="text-success">Org Name: </span>:{' '}
              {symtomsById[0].orgName}
            </p>
            <p className="m-0">
              <span className="text-success">Admission Department: </span> :
              {symtomsById[0].admissionDepartment}
            </p>
            <p className="m-0">
              <span className="text-success">Consulting Dr: </span>:{' '}
              {symtomsById[0].consultingDr}
            </p>
            <p className="m-0">
              <span className="text-success">Type: </span>:{' '}
              {symtomsById[0].type}
            </p>
            <p className="m-0">
              <span className="text-success">Symptoms: </span>:{' '}
              {symtomsById[0].symptoms}
            </p>
            <p className="m-0">
              <span className="text-success">Ancestral Hisotry Flag: </span>:
              {symtomsById[0].ancestralHisotryFlag}
            </p>
            <p className="m-0">
              <span className="text-success">Surgery History Flag: </span>:
              {symtomsById[0].surgeryHistoryFlag}
            </p>
            <p className="m-0">
              <span className="text-success">Prescription: </span>:{' '}
              {symtomsById[0].prescription}
            </p>
            <p className="m-0">
              <span className="text-success">Tests: </span>:{' '}
              {symtomsById[0].tests}
            </p>
            <p className="m-0">
              <span className="text-success">Visitig Date: </span>:{' '}
              {new Date(symtomsById[0].date).toLocaleDateString()}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
